import { render, staticRenderFns } from "./color-menu-content.vue?vue&type=template&id=c04c7ba6&scoped=true"
import script from "./color-menu-content.vue?vue&type=script&lang=js"
export * from "./color-menu-content.vue?vue&type=script&lang=js"
import style0 from "./color-menu-content.vue?vue&type=style&index=0&id=c04c7ba6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c04c7ba6",
  null
  
)

/* custom blocks */
import block0 from "./color-menu-content.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports